import React, { useRef, useState, useEffect } from 'react';

interface MobileFileUploadProps {
  label?: string;
  file: File | null;
  onChange: (file: File | null) => void;
  accept?: string;
  placeholder?: string;
}

const MobileFileUpload: React.FC<MobileFileUploadProps> = ({ label, file, onChange, accept = 'image/*,application/pdf', placeholder = 'Add attachment' }) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  useEffect(() => {
    if (file && file.type.startsWith('image/')) {
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
      return () => URL.revokeObjectURL(url);
    }
    setPreviewUrl(null);
  }, [file]);

  return (
    <div>
      {label && <label className="block text-sm text-gray-700 mb-1">{label}</label>}
      <div className="border rounded-xl bg-white overflow-hidden">
        {/* Preview area */}
        {previewUrl ? (
          <div className="relative">
            <img src={previewUrl} alt="attachment" className="w-full max-h-40 object-cover" />
            <button
              type="button"
              onClick={() => onChange(null)}
              className="absolute top-2 right-2 bg-black/60 text-white rounded-full w-8 h-8 flex items-center justify-center"
              aria-label="Remove attachment"
            >
              ✕
            </button>
          </div>
        ) : (
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            className="w-full flex items-center justify-center gap-2 py-3 text-primary bg-primary/5"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l-4-4m4 4l4-4" />
            </svg>
            <span className="font-medium">{placeholder}</span>
          </button>
        )}

        {/* File meta row */}
        {file && (
          <div className="px-3 py-2 text-xs text-gray-600 border-t truncate">
            {file.name} · {Math.max(1, Math.round(file.size / 1024))} KB
          </div>
        )}
      </div>

      <input
        ref={inputRef}
        type="file"
        accept={accept}
        className="hidden"
        onChange={(e) => onChange(e.target.files && e.target.files[0] ? e.target.files[0] : null)}
      />
    </div>
  );
};

export default MobileFileUpload;


